 
import BrokerService from "../../services/broker.service";
import { getBrokers } from "../../api/authentication";
import { 
  getBasketPositions, 
  getBasketOrders, 
  getBasketTrades, 
  getBasketLogs,
  getBasket,
  updateBasket,
  updateBasketName,
  getBasketPnlMtm,
  getStrategyPositions,
  getStrategyOrders,
  getStrategyTrades,
  getStrategyLogs
} from "../../api/strategyApi";
import { SAVE_BASKET_SLTP, SAVE_BROKER_SLTP, STRATEGY_GROPING, SAVE_QUIK_KEY, SAVE_POSITION_MARGE, SAVE_INSTRUMENT_CONFIG, IS_ORDER_FIRED, SAVE_WINDOW_SCREEN, SAVE_TOP_FILTER_VALUES, SAVE_ORDERS, SAVE_MARGIN ,  SAVE_POSITION,SET_SUSCRIPTIONS, ADD_BASKET, REMOVE_BASKET, SAVE_SOCKET_JWT_TOKEN, SAVE_FUNDS, SAVE_POSITION_TOKEN, SET_LOGIN_CHECK, SAVE_TRADE_FEED_SOURCE, SAVE_SOCK_SOURCE, SAVE_BROKERS_LIST } from "../../util/actionTypes.js";
import Store  from '../../redux';
import { message } from "antd";
import { config } from "@fortawesome/fontawesome-svg-core";
import { DummyData } from "./FeedData.js";
import moment from "moment";
import { toast } from "components/common/custom-toast/Toast";

const getHeaders = () => {
    const user = Store?.getState()?.user;
    return {
        'X-FNOTRADER-SECRET': user?.loginSecret,
        'X-FNOTRADER-USERID': user?.userID
    };
}

export const getjwtAction = () => async (dispatch) => {
 
    await fetch(`${process.env.REACT_APP_TRADE_API_URL_LOGIN}/token`, {
        headers: getHeaders()
    }).then(res => {
      if (res.ok) {
          res.json().then((data)=>{
              const token = {token:res.headers.get('jwt'), wsId:data.wsId};
              dispatch({
                type: SAVE_SOCKET_JWT_TOKEN,
                payload: token
              });
              return token;
          })
        }       
    })
    .catch(err => {
        console.log("error while fetching token", err);
    });
     
};

export const saveTradeFeedSource = (source) => ({
  type: SAVE_TRADE_FEED_SOURCE,
  payload: source
});

export const saveSockSource = (source) => ({
  type: SAVE_SOCK_SOURCE,
  payload: source
});

 
export const WindowScreenAction = (data) => {
  return {
      type: SAVE_WINDOW_SCREEN,
      payload: data
  };
};
export const topHeaderAction = (data) => {
  return {
      type: SAVE_TOP_FILTER_VALUES,
      payload: data
  };
};

export const basketAction = (data) => {
 
  return {
      type: ADD_BASKET,
      payload: data
  };
};

export const removebasketAction = (data) => {
  return {
      type: REMOVE_BASKET,
      payload: data
  };
};

export const placeOrdersAction = (parma,broker_id, orderFrom) => async (dispatch) => {

  const res = await BrokerService.placeOrders(parma, broker_id);
  try {        
    if (res) {
       if (res.code === 403) {
        toast.error(res.error);
        return { sessionExpired : true, message:res };
      }
      if (res.code === 400) {
        toast.error(res.error);
      }
      const data = res.ids; 
 
      if (data) {
        if(orderFrom === "basket") {
          setTimeout(()=>{
            dispatch({
              type: IS_ORDER_FIRED,
              payload: data,
            });
          },2000)
           
        }
        return data;
      }
    }  else {
      console.log("error response code place_orders");
    }
  } catch (error) {
    console.log(
      "error processing place_orders request :",
      error
    );
  }
};
 

 
export const ListOrdersAction = (broker_id) => async (dispatch) => {
 
  const res = await BrokerService.ListOrders(broker_id);

   
  try {
    
    if (res.code === 200) {
      const data = res?.data?.sort((a, b)=>new Date(b.orderTime)- new Date(a.orderTime)); 
      if (data) {
        dispatch(saveOrders(data))
        return data;
      } else {
        dispatch(saveOrders([]))
      }
    } else if (res.code === 403) {
      toast.error(res.error);
      return { sessionExpired : true };
    } else if(res.error) {
      toast.error(res.error || "error response code ListOrders");
      console.log("error response code ListOrders");
    }
  } catch (error) {
    console.log(
      "error processing ListOrders request :",
      error
    );
  }
};
 


export const modifyOrderAction = (parma,broker_id) => async (dispatch) => {
 
  const res = await BrokerService.modifyOrder(parma,broker_id);
  try {
    
    if (res.code === 200) {
      const data = res.data; 
      if (data) {
        return data;
      }
    } else if (res.code === 403) {
      toast.error(res.error);
      return { sessionExpired : true };
    } else if(res.error) {
      toast.error(res.error || "error response code modify_order");
      console.log("error response code modify_order");
    }
  } catch (error) {
    console.log(
      "error processing modify_order request :",
      error
    );
  }
};

export const cancelOrderAction = (parma,broker_id) => async (dispatch) => {
 
  const res = await BrokerService.cancelOrder(parma,broker_id);
  try {
    
    if (res.code === 200) {
      const data = res.data; 
      if (data) {
        return data;
      }
    } else if (res.code === 403) {
      toast.error(res.error);
      return { sessionExpired : true };
    } else if(res.error) {
      toast.error(res.error || "error response code cancel_orders");
      console.log("error response code cancel_orders");
    }
  } catch (error) {
    console.log(
      "error processing cancel_orders request :",
      error
    );
  }
};


export const ListPositionsAction = (broker_id) => async (dispatch) => {
 
 // return  DummyData.data

  const res = await BrokerService.ListPositions(broker_id);
  try { 

     
    
    if (res.code === 200) {
      const data = res.data; 
      if (data) {
      
        dispatch(positionsAction(data));
        return data;
      } else {
        dispatch(positionsAction([]));
        dispatch(positionsActionDis([]))
      }
    } else if (res.code === 403) {
      toast.error(res.error);
      return { sessionExpired : true };
    } else if(res.error) {
      toast.error(res.error || "error response code positions");
      console.log("error response code positions");
    }
  } catch (error) {
    console.log(
      "error processing positions request :",
      error
    );
  }
};

export const chanageBasketAction = (params) => async (dispatch) => {
 
  const res = await BrokerService.chanageBasket(params);
   
  try {
    const data = res.data || []; 
    return {status:true, data:data};
    if (res.code === 200) {
        
        return {status:true, data:data};
       
    } else if (res.code === 403) {
      toast.error(res.error);
      return{status:false, sessionExpired : true};

    } else if(res.error) {
      toast.error(res.error || "error response code positions/basket/add");
      console.log("error response code positions/basket/add");
      return {status:false};

    }
  } catch (error) {
    console.log(
      "error processing positions/basket/add request :",
      error
    );
  }
};
export const removeBasketAction = (params) => async (dispatch) => {
 
  const res = await BrokerService.removeBasket(params);
   
  try {
      return {status:true};
    if (res.code === 200) {
        return {status:true};
    } else if (res.code === 403) {
      toast.error(res.error);
      return { status:false, sessionExpired : true };
    } else if(res.error) {
      toast.error(res.error || "error response code positions/basket/remove");
      console.log("error response code positions/basket/remove");
      return {status:false};
    }
  } catch (error) {
    console.log(
      "error processing positions/basket/remove request :",
      error
    );
    return {status:false};
    console.log(
      "error processing positions/basket/remove request :",
      error
    );
  }
};


export const brokerSyncAction = (broker_id) => async (dispatch) => {
  const res = await BrokerService.brokerSync(broker_id);
  try {
    
    if (res.code === 200) {
      toast.success("Broker sync completed successfully");
    } else if (res.code === 403) {
      toast.error(res.error);
      return { status:false, sessionExpired : true };
    } else if(res.error) {
      toast.error(res.error || "error response code broker/sync");
      console.log("error response code broker/sync");
    }
  } catch (error) {
    console.log(
      "error processing broker/sync request :",
      error
    );
  }
};

export const brokerResetAndSyncAction = (broker_id) => async (dispatch) => {
  const res = await BrokerService.brokerResetAndSync(broker_id);
  try {
    
    if (res.code === 200) {
      toast.success("Broker reset and sync completed successfully");
    } else if (res.code === 403) {
      toast.error(res.error);
      return { status:false, sessionExpired : true };
    } else if(res.error) {
      toast.error(res.error || "error response code broker/sync");
      console.log("error response code broker/sync");
    }
  } catch (error) {
    console.log(
      "error processing broker/sync request :",
      error
    );
  }
};

export const positionsSyncAction = (broker_id) => async (dispatch) => {
  const res = await BrokerService.positionsSync(broker_id);
  try {
    
    if (res.code === 200) {
       return {status:true}
    } else if (res.code === 403) {
      toast.error(res.error);
      return { status:false, sessionExpired : true };
    } else if(res.error) {
      toast.error(res.error || "error response code positions/sync");
      console.log("error response code positions/sync");
    }
  } catch (error) {
    console.log(
      "error processing positions/sync request :",
      error
    );
  }
};

export const ordersSyncAction = (broker_id) => async (dispatch) => {
  const res = await BrokerService.ordersSync(broker_id);
  try {
    
    if (res.code === 200) {
       return {status:true}
    } else if (res.code === 403) {
      toast.error(res.error);
      return { status:false, sessionExpired : true };
    } else if(res.error) {
      toast.error(res.error || "error response code orders/sync");
      console.log("error response code orders/sync");
    }
  } catch (error) {
    console.log(
      "error processing orders/sync request :",
      error
    );
  }
};

export const getSyncStatusAction = (broker_id) => async (dispatch) => {
  const res = await BrokerService.getSyncStatus(broker_id);
  try {
    if (res.code === 200) {
       return {status:true, data: res.data}
    } else if (res.code === 403) {
      toast.error(res.error);
      return { status:false, sessionExpired : true };
    } else if(res.error) {
      toast.error(res.error || "error response code sync/status");
      console.log("error response code sync/status");
      return { status:false };
    }
  } catch (error) {
    console.log(
      "error processing sync/status request :",
      error
    );
    return { status:false };
  }
};

export const getlogsAction = (broker_id) => async (dispatch) => {
  const res = await BrokerService.getlogs(broker_id);
  try {
    
    if (res.code === 200) {
      const data = res.data; 
      if (data) {
         return data;
      }
    } else if (res.code === 403) {
      toast.error(res.error);
      return { status:false, sessionExpired : true };
    } else if(res.error) {
      toast.error(res.error || "error response code logs");
      console.log("error response code logs");
    }
  } catch (error) {
    console.log(
      "error processing logs request :",
      error
    );
  }
};

export const getFundsAction = (broker_id) => async (dispatch) => {
  const res = await BrokerService.getFunds(broker_id);
  try {
    
    if (res.code === 200) {
      const data = res.data; 
      if (data) {
        dispatch({
          type: SAVE_FUNDS,
          payload: data,
        });

         return data;
      }
    } else if (res.code === 403) {
      toast.error(res.error);
      return { status:false, sessionExpired : true };
    } else if(res.error) {
      toast.error(res.error || "error response code funds");
      console.log("error response code funds");
    }
  } catch (error) {
    console.log(
      "error processing funds request :",
      error
    );
  }
};

export const getMarginAction = (broker_id, params) => async (dispatch) => {
  if(params?.orders?.length === 0) {
    dispatch({
      type: SAVE_MARGIN,
      payload: [],
    });
    return false;
  }
  const res = await BrokerService.getMargin(broker_id, params);
  try {
    if (res.code === 200) {
      const data = res.data; 
      if (data) {
        dispatch({
          type: SAVE_MARGIN,
          payload: data,
        });
         return {status:true, data:data};
      }
    } else if (res.code === 403) {
      toast.error(res.error);
      return { status:false, sessionExpired : true };
    } else if(res.error) {
      toast.error(res.error || "error response code margin");
      console.log("error response code margin");
      return { status:false };
    }
  } catch (error) {
    console.log(
      "error processing margin request :",
      error
    );
  }
};

export const getTradesAction = (broker_id) => async (dispatch) => {
  const res = await BrokerService.getTrades(broker_id);
  try {
    
    if (res.code === 200) {
      const data = res.data; 
      if (data) {
         return data;
      }
    } else if (res.code === 403) {
      toast.error(res.error);
      return { status:false, sessionExpired : true };
    } else if(res.error) {
      toast.error(res.error || "error response code trades");
      console.log("error response code trades");
    }
  } catch (error) {
    console.log(
      "error processing trades request :",
      error
    );
  }
};

export const updatePositionAction = (position_id, params) => async (dispatch) => {
  const res = await BrokerService.updatePosition(position_id, params);
  try {
    
    if (res.code === 200) {
      return { status:true };
    } else if (res.code === 403) {
      toast.error(res.error);
      return { status:false, sessionExpired : true };
    } else if(res.error) {
      toast.error(res.error || "error response code UpdatePosition");
      console.log("error response code UpdatePosition");
      return { status:false };
    }
  } catch (error) {
    console.log(
      "error processing UpdatePosition request :",
      error
    );
  }
};

export const updateBasketAction = (basket_id, params) => async (dispatch) => {
  const res = await BrokerService.updateBasket(basket_id, params);
  try {
    
    if (res.code === 200) {
      return { status:true};
    } else if (res.code === 403) {
      toast.error(res.error);
      return { status:false, sessionExpired : true };
    } else if(res.error) {
      toast.error(res.error || "error response code updateBasket");
      console.log("error response code updateBasket");
      return { status:false };
    }
  } catch (error) {
    console.log(
      "error processing UpdateBasket request :",
      error
    );
  }
};

export const getBasketAction = (basket_id) => async (dispatch) => {
  const res = await BrokerService.getBasket(basket_id);
  try {
    
    if (res.code === 200) {
     
      return { status:true, data:res.data };
    } else if (res.code === 403) {
      toast.error(res.error);
      return { status:false, sessionExpired : true };
    } else if(res.error) {
      toast.error(res.error || "error response code getBasket");
      console.log("error response code getBasket");
      return { status:false };
    }
  } catch (error) {
    console.log(
      "error processing getBasket request :",
      error
    );
  }
};

export const getBasketPositionsAction = (basket_id) => async (dispatch) => {
  const res = await getBasketPositions(basket_id);
  try {
    if (res.code === 200) {
      const data = res.data; 
      if (data) {
        return data;
      } else {
        return [];
      }
    } else if (res.code === 403) {
      toast.error(res.error);
      return { sessionExpired : true };
    } else if(res.error) {
      toast.error(res.error || "error response code getBasketPositions");
      console.log("error response code getBasketPositions");
    }
  } catch (error) {
    console.log(
      "error processing getBasketPositions request :",
      error
    );
  }
};

export const getBasketOrdersAction = (basket_id) => async (dispatch) => {
  const res = await getBasketOrders(basket_id);
  try {
    if (res.code === 200) {
      const data = res.data; 
      if (data) {
        return data;
      } else {
        return [];
      }
    } else if (res.code === 403) {
      toast.error(res.error);
      return { sessionExpired : true };
    } else if(res.error) {
      toast.error(res.error || "error response code getBasketOrders");
      console.log("error response code getBasketOrders");
    }
  } catch (error) {
    console.log(
      "error processing getBasketOrders request :",
      error
    );
  }
};

export const getBasketTradesAction = (basket_id) => async (dispatch) => {
  const res = await getBasketTrades(basket_id);
  try {
    if (res.code === 200) {
      const data = res.data; 
      if (data) {
        return data;
      } else {
        return [];
      }
    } else if (res.code === 403) {
      toast.error(res.error);
      return { sessionExpired : true };
    } else if(res.error) {
      toast.error(res.error || "error response code getBasketTrades");
      console.log("error response code getBasketTrades");
    }
  } catch (error) {
    console.log(
      "error processing getBasketTrades request :",
      error
    );
  }
};

export const getBasketLogsAction = (basket_id) => async (dispatch) => {
  const res = await getBasketLogs(basket_id);
  try {
    if (res.code === 200) {
      const data = res.data; 
      if (data) {
        return data;
      } else {
        return [];
      }
    } else if (res.code === 403) {
      toast.error(res.error);
      return { sessionExpired : true };
    } else if(res.error) {
      toast.error(res.error || "error response code getBasketLogs");
      console.log("error response code getBasketLogs");
    }
  } catch (error) {
    console.log(
      "error processing getBasketLogs request :",
      error
    );
  }
};

export const getStrategyPositionsAction = (strategy_id) => async (dispatch) => {
  const res = await getStrategyPositions(strategy_id);
  try {
    if (res.code === 200) {
      const data = res.data; 
      if (data) {
        return data;
      } else {
        return [];
      }
    } else if (res.code === 403) {
      toast.error(res.error);
      return { sessionExpired : true };
    } else if(res.error) {
      toast.error(res.error || "error response code getStrategyPositions");
      console.log("error response code getStrategyPositions");
    }
  } catch (error) {
    console.log(
      "error processing getStrategyPositions request :",
      error
    );
  }
};

export const getStrategyOrdersAction = (strategy_id) => async (dispatch) => {
  const res = await getStrategyOrders(strategy_id);
  try {
    if (res.code === 200) {
      const data = res.data; 
      if (data) {
        return data;
      } else {
        return [];
      }
    } else if (res.code === 403) {
      toast.error(res.error);
      return { sessionExpired : true };
    } else if(res.error) {
      toast.error(res.error || "error response code getStrategyOrders");
      console.log("error response code getStrategyOrders");
    }
  } catch (error) {
    console.log(
      "error processing getStrategyOrders request :",
      error
    );
  }
};

export const getStrategyTradesAction = (strategy_id) => async (dispatch) => {
  const res = await getStrategyTrades(strategy_id);
  try {
    if (res.code === 200) {
      const data = res.data; 
      if (data) {
        return data;
      } else {
        return [];
      }
    } else if (res.code === 403) {
      toast.error(res.error);
      return { sessionExpired : true };
    } else if(res.error) {
      toast.error(res.error || "error response code getStrategyTrades");
      console.log("error response code getStrategyTrades");
    }
  } catch (error) {
    console.log(
      "error processing getStrategyTrades request :",
      error
    );
  }
};

export const getStrategyLogsAction = (strategy_id) => async (dispatch) => {
  const res = await getStrategyLogs(strategy_id);
  try {
    if (res.code === 200) {
      const data = res.data; 
      if (data) {
        return data;
      } else {
        return [];
      }
    } else if (res.code === 403) {
      toast.error(res.error);
      return { sessionExpired : true };
    } else if(res.error) {
      toast.error(res.error || "error response code getStrategyLogs");
      console.log("error response code getStrategyLogs");
    }
  } catch (error) {
    console.log(
      "error processing getStrategyLogs request :",
      error
    );
  }
};

export const updateBasketNameAction = (basket_id, params) => async (dispatch) => {
  const res = await BrokerService.updateBasketName(basket_id, params);
  try {

    return { status:true, message:"Basket name updated successfully" };
    
    if (res.code === 200) {
 
      return { status:true, data:res.data };
    } else if (res.code === 403) {
      toast.error(res.error);
      return { status:false, sessionExpired : true };
    } else if(res.error) {
      toast.error(res.error || "error response code UpdateBasketName");
      console.log("error response code UpdateBasketName");
      return { status:false };
    }
  } catch (error) {
    console.log(
      "error processing UpdateBasketName request :",
      error
    );
  }
};

export const updateInstrumentConfigAction = (basket_id,instrument_token, params) => async (dispatch) => {
  const res = await BrokerService.updateInstrumentConfig(basket_id,instrument_token, params);
    if(res.error){
      toast.error(res.error || "error response code updateInstrumentConfig");
      console.log("error response code updateInstrumentConfig");
      return { status:false };
    }else{
      return { status:true }; 
    }
};

export const getInstrumentConfigAction = (brokerId,instrument_token) => async (dispatch) => {
  const res = await BrokerService.getInstrumentConfig(brokerId,instrument_token);
  const brokerConfig = await BrokerService.getBrokerConfig(brokerId);

  try {
      
    if (res.code === 200) {
      if(brokerConfig) {
        dispatch(saveInstrumentConfig({...res.data, ...brokerConfig.data}))
        return { status:true, data:{...res.data, ...brokerConfig.data} };
      } else {
        dispatch(saveInstrumentConfig({...res.data, ...{config:false}}))
        return { status:true, data:{...res.data, ...{config:false}} };

      }
    } else if (res.code === 403) {
      toast.error(res.error);
      return { status:false, sessionExpired : true };
    } else if(res.error) {
      toast.error(res.error || "error response code getInstrumentConfig");
      console.log("error response code getInstrumentConfig");
      return { status:false, data:{} };
    }
  } catch (error) {
    console.log(
      "error processing getInstrumentConfig request :",
      error
    );
  }
};

export const getBrokerConfigAction = (brokerId) => async (dispatch) => {
  const res = await BrokerService.getBrokerConfig(brokerId);
  try {
      
    if (res.code === 200) {
      return { status:true, data:res.data };
    } else if (res.code === 403) {
      toast.error(res.error);
      return { status:false, sessionExpired : true };
    } else if(res.error) {
      toast.error(res.error || "error response code getBrokerConfig");
      console.log("error response code getBrokerConfig");
      return { status:false, data:{} };
    }
  } catch (error) {
    console.log(
      "error processing getBrokerConfig request :",
      error
    );
  }
};


export const updateBrokerConfigAction = (basket_id, params) => async (dispatch) => {
  const res = await BrokerService.updateBrokerConfig(basket_id, params);
  try {
      
    if (res.code === 200) {
      return { status:true, data:res.data };
    } else if (res.code === 403) {
      toast.error(res.error);
      return { status:false, sessionExpired : true };
    } else if(res.error) {
      toast.error(res.error || "error response code updateBrokerConfig");
      console.log("error response code updateBrokerConfig");
      return { status:false, data:{} };
    }
  } catch (error) {
    console.log(
      "error processing updateBrokerConfig request :",
      error
    );
  }
};
export const UpdateBrokerActionPnl = (broker_id, params) => async (dispatch) => {
  const res = await BrokerService.UpdateBroker(broker_id, params);
  try {
      
    if (res) {
      return { status:true };
    } else if (res.code === 403) {
      toast.error(res.error);
      return { status:false, sessionExpired : true };
    } else if(res.error) {
      toast.error(res.error || "error response code UpdateBroker SLTP");
      console.log("error response code UpdateBroker SLTP");
      return { status:false, data:{} };
    }
  } catch (error) {
    console.log(
      "error processing UpdateBroker request :",
      error
    );
  }
};

export const  GetBrokerActionPnl = (broker_id) => async (dispatch) => {
  const res = await BrokerService.GetBroker(broker_id);
  try {
      
    if (res.code === 200) {
       dispatch(saveBrokerSLTP(res.data))
      return { status:true, data:res.data };
    } else if (res.code === 403) {
      toast.error(res.error);
      return { status:false, sessionExpired : true };
    } else if(res.error) {
      toast.error(res.error || "error response code GetBroker");
      console.log("error response code GetBroker");
      return { status:false, data:{} };
    }
  } catch (error) {
    console.log(
      "error processing GetBroker request :",
      error
    );
  }
};

export const positionsActionDis = (data) => async (dispatch) => {
  dispatch({
    type: SAVE_POSITION_MARGE,
    payload: data,
  });
}

export const positionsAction = (data) => async (dispatch) => {
 
    dispatch({
      type: SAVE_POSITION,
      payload: data,
    });
}


export const positionsTokanAction = (data) => async (dispatch) => {
  dispatch({
    type: SAVE_POSITION_TOKEN,
    payload: data,
  });
}

export const saveOrders = (data) => async (dispatch) => {
  dispatch({
    type: SAVE_ORDERS,
    payload: data,
  });
}

export const saveInstrumentConfig = (data) => async (dispatch) => {
  dispatch({
    type: SAVE_INSTRUMENT_CONFIG,
    payload: data,
  });
}


export const specialSession = async (type) => {
  const res = await BrokerService.specialSession(type);
  try {
    if (res.code === 200) {
      const data = res.data;
      if (data) {
        return data;
      }
    } else if (res.code === 403) {
      return { sessionExpired: true };
    } else {
      console.log("error response ");
    }
  } catch (error) {
    console.log("error processing  request :", error);
  }
};

export const getSuscriptions = (status) => async (dispatch) => {
  console.log("=======API Calling=========");
  
   const res = await BrokerService.getSuscriptions();
   try {
     
     if (res.code === 200) {
       const data = res.data; 
        const filterProPayment = data.payments.filter((item)=> {
        if(item.packageEndTime) {
          const currentDate = moment();
          const EndTime = moment(item.packageEndTime);  
          if((item.planId === "QT04" || item.planId === "QT05" ||  item.planId === "QT06") && EndTime.diff(currentDate, 'days') > 0) {
            return item; 
           }
         }
       })
       const filterScalperPayment = data.payments.filter((item)=> {
        if(item.packageEndTime) {
          const currentDate = moment();
          const EndTime = moment(item.packageEndTime);  
          if((item.planId === "QT01" || item.planId === "QT02" ||  item.planId === "QT03") && EndTime.diff(currentDate, 'days') > 0) {
            return item; 
           }
         }
       })
       const filterTrialPayment = data.payments.filter((item)=> {
        if(item.packageEndTime) {
          const currentDate = moment();
          const EndTime = moment(item.packageEndTime);  
          if((item.productType === "qt" && item.planId === "trial") && EndTime.diff(currentDate, 'days') > 0) {
            return item; 
           }
         }
       })
       const packages = {
         proPlan:filterProPayment,
         scalperPlan:filterScalperPayment,
         trial:filterTrialPayment,
         payments: data.payments
       }
       
       if (data) {
         dispatch({
           type: SET_SUSCRIPTIONS,
           payload: packages,
         });
       }
     } else if (res.code === 403) {
       
       return { sessionExpired : true };
     } else {
       console.log("error response code getSuscriptions");
     }
   } catch (error) {
     console.log(
       "error processing getSuscriptions names request :",
       error
     );
   }
 };


 export const quckAction = (data) => async (dispatch) => {
  dispatch({
    type: SAVE_QUIK_KEY,
    payload: data,
  });
}

export const strategyGroupingAction = (data) => async (dispatch) => {
  dispatch({
    type: STRATEGY_GROPING,
    payload: data,
  });
}

export const saveBasketSLTP = (data) => async (dispatch) => {
  dispatch({
    type: SAVE_BASKET_SLTP,
    payload: data,
  });
}

export const saveBrokerSLTP = (data) => async (dispatch) => {
  dispatch({
    type: SAVE_BROKER_SLTP,
    payload: data,
  });
}

export const getMwplandBanList = async (date) => {
  try {
    if (date) {
      const res = await BrokerService.getMwplandBanListRequest(date);
      if (res.code === 200) {
        return res.data;
      } else if (res.code === 403) {
        toast.error(res.error);
        return { sessionExpired: true };
      }else if(res.error) {
        toast.error(res.error || "error response code getMwplandBanList");
        console.log("error response code getMwplandBanList");
        return null;
      }
    }
  } catch (error) {
    console.log('error processing get History Chart Data request :', error);
  }
};

export const getAllBrokersList = () => async (dispatch) => {
  try {
    const res = await BrokerService.getBrokers();
    if (res.code === 200) {
      const brokers = res?.data?.brokers || [];
      const sortedBrokers = brokers.sort((a, b) => a.type.localeCompare(b.type));
      dispatch({ type: SAVE_BROKERS_LIST, payload: sortedBrokers });
      return { brokers: sortedBrokers };
    } else if (res.code === 403) {
      toast.error(res.error);
      return { sessionExpired: true };
    } else if(res.error) {
      toast.error(res.error || "error response code getBrokerList");
      console.log("error response code getBrokerList");
      return null;
    }
  } catch (error) {
    console.log("error processing getBrokerList request:", error);
    return null;
  }
};

export const getBrokerList = (status) => async (dispatch) => {
  try {
    const res = await getBrokers(status);
    if (res.code === 200) {
      const brokers = res?.data?.brokers?.filter((item) => item.quickTrade);
      return { brokers: brokers };
    } else if (res.code === 403) {
      toast.error(res.error);
      return { sessionExpired: true };
    } else if(res.error) {
      toast.error(res.error || "error response code getBrokerList");
      console.log("error response code getBrokerList");
      return null;
    }
  } catch (error) {
    console.log("error processing getBrokerList request:", error);
    return null;
  }
};

export const loginCheckAction = (data) => {
  return {
      type: SET_LOGIN_CHECK,
      payload: data
  };
};

export const getUserBrokerCountAction = async() => {
  try{
    const res = await BrokerService.getUserBrokerCount();
    if(res.code === 200){
      return res.data;
    }else if(res.code === 403){
      toast.error(res.error);
      return { sessionExpired: true };
    }else if(res.error){
      toast.error(res.error || "error response code getUserBrokerCount");
      console.log("error response code getUserBrokerCount");
      return null;
    }
  }catch(error){
    console.log("error processing getUserBrokerCount request:", error);
    return null;
  }
}

export const setBrokerPurposeAction = (broker_id, purpose) => async (dispatch) => {
  try {
    const res = await BrokerService.setBrokerPurpose(broker_id, purpose);
    if (res.code === 200) {
      dispatch(getAllBrokersList());
      return { status: true };
    } else if (res.code === 403) {
      toast.error(res.error);
      return { status: false, sessionExpired: true };
    } else if (res.error) {
      toast.error(res.error || "error setting broker purpose");
      return { status: false, error: res.error };
    }
  } catch (error) {
    console.error("error processing setBrokerPurpose request:", error);
    return { status: false };
  }
};

export const getBrokerQuiktradeAction = (broker_id) => async (dispatch) => {
  try {
    const res = await BrokerService.getBrokerQuiktrade(broker_id);
    if (res.code === 200) {
      return { status: true, data: res.data };
    } else if (res.code === 403) {
      toast.error(res.error);
      return { status: false, sessionExpired: true };
    } else if (res.error) {
      console.log("error response code getBrokerQuiktrade");
      return { status: false };
    }
  } catch (error) {
    console.error("error processing getBrokerQuiktrade request:", error);
    return { status: false };
  }
};